/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/store/actions/app.actions.js
 * File: app.actions.js
 * Created Date: Sunday, January 27th 2019, 7:15:56 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Mon Jan 28 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import { resolveApp } from 'client/app/services/app.service'

export const GET_APP_DATA = '[APP] GET APP DATA'
export const GET_APP_DATA_SUCCESS = '[APP] GET APP DATA SUCCESS'
export const GET_APP_DATA_FAILURE = '[APP] GET APP DATA FAILURE'

export const SET_FUSE_TOOLBAR_TITLE = '[APP] SET TOOLBAR TITLE'

export function getAppData (event) {
  return (dispatch, getState) => {
    dispatch(getAppDataRequest())
    return resolveApp()
      .then(response => {
        dispatch(getAppDataSuccess(response))
        return (response)
      })
      .catch(err => {
        dispatch(getAppDataFail(err))
        return (err)
      })
  }
}

export function setToolbarTitle (title = '') {
  return (dispatch) => {
    dispatch({
      type: SET_FUSE_TOOLBAR_TITLE,
      title
    })
  }
}

function getAppDataRequest () {
  return {
    type: GET_APP_DATA
  }
}

function getAppDataSuccess (data = {}) {
  return {
    type: GET_APP_DATA_SUCCESS,
    data
  }
}

function getAppDataFail (error) {
  return {
    type: GET_APP_DATA_FAILURE,
    error
  }
}
